<div class="add-container">
    <h1 class="add-title">Editare registru</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- Form fields for Administrator Drum -->
        <div *ngIf="inputData.slug === 'acord_administrator_drum'">
            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>

            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error *ngIf="
                        !form.controls['data_eliberarii'].valid &&
                        form.controls['data_eliberarii'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Adresă imobil</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Suprafață</h3>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață teren</mat-label>
                        <input type="number" matInput formControlName="suprafata_teren" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_teren'].valid && form.controls['suprafata_teren'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață construcție</mat-label>
                        <input type="number" matInput formControlName="suprafata_constructie" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_constructie'].valid && form.controls['suprafata_constructie'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață desfășurată</mat-label>
                        <input type="number" matInput formControlName="suprafata_desfasurata" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_desfasurata'].valid && form.controls['suprafata_desfasurata'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață utilă</mat-label>
                        <input type="number" matInput formControlName="suprafata_utila" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_utila'].valid && form.controls['suprafata_utila'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață bucătării</mat-label>
                    <input type="number" matInput formControlName="suprafata_bucatarii" />
                    <mat-error
                        *ngIf="!form.controls['suprafata_bucatarii'].valid && form.controls['suprafata_bucatarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valoare</mat-label>
                    <input type="number" matInput formControlName="valoare" />
                    <mat-error *ngIf="!form.controls['valoare'].valid && form.controls['valoare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Termen de valabilitate</mat-label>
                    <input matInput [matDatepicker]="picker_valabilitate" formControlName="valabilitate" readonly
                        (focus)="picker_valabilitate.open()" />
                    <mat-error *ngIf="
                        !form.controls['valabilitate'].valid &&
                        form.controls['valabilitate'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_valabilitate"></mat-datepicker-toggle>
                    <mat-datepicker #picker_valabilitate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Durată execuție</mat-label>
                    <input type="number" matInput formControlName="durata_executie" />
                    <mat-error
                        *ngIf="!form.controls['durata_executie'].valid && form.controls['durata_executie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Form fields for Autorizatii de construire -->
        <div *ngIf="inputData.slug === 'autorizatii-construire'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr autorizație</mat-label>
                    <input type="number" matInput formControlName="numar_autorizatie" />
                    <mat-error
                        *ngIf="!form.controls['numar_autorizatie'].valid && form.controls['numar_autorizatie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_eliberarii'].valid &&
                                form.controls['data_eliberarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_solicitarii'].valid &&
                                form.controls['data_solicitarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Adresă imobil</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Suprafață</h3>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață teren</mat-label>
                        <input type="number" matInput formControlName="suprafata_teren" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_teren'].valid && form.controls['suprafata_teren'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață construcție</mat-label>
                        <input type="number" matInput formControlName="suprafata_constructie" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_constructie'].valid && form.controls['suprafata_constructie'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață desfășurată</mat-label>
                        <input type="number" matInput formControlName="suprafata_desfasurata" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_desfasurata'].valid && form.controls['suprafata_desfasurata'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață utilă</mat-label>
                        <input type="number" matInput formControlName="suprafata_utila" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_utila'].valid && form.controls['suprafata_utila'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață bucătării</mat-label>
                    <input type="number" matInput formControlName="suprafata_bucatarii" />
                    <mat-error
                        *ngIf="!form.controls['suprafata_bucatarii'].valid && form.controls['suprafata_bucatarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valoare</mat-label>
                    <input type="number" matInput formControlName="valoare" />
                    <mat-error *ngIf="!form.controls['valoare'].valid && form.controls['valoare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Termen de valabilitate</mat-label>
                    <input matInput [matDatepicker]="picker_valabilitate" formControlName="valabilitate" readonly
                        (focus)="picker_valabilitate.open()" />
                    <mat-error *ngIf="
                                !form.controls['valabilitate'].valid &&
                                form.controls['valabilitate'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_valabilitate"></mat-datepicker-toggle>
                    <mat-datepicker #picker_valabilitate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Durată execuție</mat-label>
                    <input type="number" matInput formControlName="durata_executie" />
                    <mat-error
                        *ngIf="!form.controls['durata_executie'].valid && form.controls['durata_executie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Form fields for Avize -->
        <div *ngIf="inputData.slug === 'avize'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr aviz</mat-label>
                    <input type="number" matInput formControlName="numar_aviz" />
                    <mat-error *ngIf="!form.controls['numar_aviz'].valid && form.controls['numar_aviz'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data intrării</mat-label>
                    <input matInput [matDatepicker]="picker_data_intrarii" formControlName="data_intrarii" readonly
                        (focus)="picker_data_intrarii.open()" />
                    <mat-error *ngIf="
                                        !form.controls['data_intrarii'].valid &&
                                        form.controls['data_intrarii'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_intrarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_intrarii></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field p-2">
                <mat-label>Tip Persoană</mat-label>
                <mat-radio-group formControlName="tip_persoana">
                    <mat-radio-button color="primary" *ngFor="let option of tipPersoanaOptions" [value]="option.value">
                        {{ option.label }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Titlul/Exemplar pe scurt</mat-label>
                    <input type="text" matInput formControlName="continut" />
                    <mat-error *ngIf="!form.controls['continut'].valid && form.controls['continut'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Dată ieșire</mat-label>
                    <input matInput [matDatepicker]="picker_data_iesire" formControlName="data_iesire" readonly
                        (focus)="picker_data_iesire.open()" />
                    <mat-error *ngIf="
                                        !form.controls['data_iesire'].valid &&
                                        form.controls['data_iesire'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_iesire"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_iesire></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_solicitarii'].valid &&
                                form.controls['data_solicitarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Adresa lucrării</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Form fields for Aviz Studiu Publicitar -->
        <div *ngIf="inputData.slug === 'aviz-principiu-studiu-publicitar'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr aviz</mat-label>
                    <input type="number" matInput formControlName="numar_aviz" />
                    <mat-error *ngIf="!form.controls['numar_aviz'].valid && form.controls['numar_aviz'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Beneficiar</mat-label>
                    <input type="text" matInput formControlName="beneficiar" />
                    <mat-error *ngIf="!form.controls['beneficiar'].valid && form.controls['beneficiar'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_solicitarii'].valid &&
                                form.controls['data_solicitarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Adresa lucrării</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Form fields for Aviz PUD || Aviz Supraetajare -->
        <div *ngIf="inputData.slug === 'aviz-pud' || inputData.slug === 'aviz-supraetajare'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr aviz</mat-label>
                    <input type="number" matInput formControlName="numar_aviz" />
                    <mat-error *ngIf="!form.controls['numar_aviz'].valid && form.controls['numar_aviz'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error *ngIf="
                                        !form.controls['data_eliberarii'].valid &&
                                        form.controls['data_eliberarii'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_solicitarii'].valid &&
                                form.controls['data_solicitarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>CNP/CUI</mat-label>
                    <input type="number" matInput formControlName="cnp_cui" />
                    <mat-error *ngIf="!form.controls['cnp_cui'].valid && form.controls['cnp_cui'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Adresă imobil</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Suprafață</h3>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață teren</mat-label>
                        <input type="number" matInput formControlName="suprafata_teren" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_teren'].valid && form.controls['suprafata_teren'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață construcție</mat-label>
                        <input type="number" matInput formControlName="suprafata_constructie" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_constructie'].valid && form.controls['suprafata_constructie'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață desfășurată</mat-label>
                        <input type="number" matInput formControlName="suprafata_desfasurata" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_desfasurata'].valid && form.controls['suprafata_desfasurata'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață utilă</mat-label>
                        <input type="number" matInput formControlName="suprafata_utila" />
                        <mat-error
                            *ngIf="!form.controls['suprafata_utila'].valid && form.controls['suprafata_utila'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață bucătării</mat-label>
                    <input type="number" matInput formControlName="suprafata_bucatarii" />
                    <mat-error
                        *ngIf="!form.controls['suprafata_bucatarii'].valid && form.controls['suprafata_bucatarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral teren</mat-label>
                    <input type="number" matInput formControlName="nr_cad_teren" />
                    <mat-error *ngIf="!form.controls['nr_cad_teren'].valid && form.controls['nr_cad_teren'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Form fields for Certificat de Urbanism -->
        <div *ngIf="inputData.slug === 'certificate-urbanism'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr certificat</mat-label>
                    <input type="number" matInput formControlName="numar_certificat" />
                    <mat-error
                        *ngIf="!form.controls['numar_certificat'].valid && form.controls['numar_certificat'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error *ngIf="
                                        !form.controls['data_eliberarii'].valid &&
                                        form.controls['data_eliberarii'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>

            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error *ngIf="
                                !form.controls['data_solicitarii'].valid &&
                                form.controls['data_solicitarii'].touched
                              ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>
            <!-- <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data intrării</mat-label>
                    <input matInput [matDatepicker]="picker_data_intrarii" formControlName="data_intrarii" readonly
                        (focus)="picker_data_intrarii.open()" />
                    <mat-error *ngIf="
                                        !form.controls['data_intrarii'].valid &&
                                        form.controls['data_intrarii'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_intrarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_intrarii></mat-datepicker>
                </mat-form-field>
            </div> -->

            <h3 class="mt-3">Adresă imobil</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Județ</mat-label>
                    <mat-select matSelect formControlName="judet">
                        <mat-option *ngFor="let judet of judete" [value]="judet.id">
                            {{ judet.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.controls['judet'].hasError('defaultSelected') && form.controls['judet'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Oraș</mat-label>
                    <input type="text" matInput formControlName="oras" />
                    <mat-error *ngIf="!form.controls['oras'].valid && form.controls['oras'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Sector</mat-label>
                    <input type="text" matInput formControlName="sector" />
                </mat-form-field>
            </div>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valabilitate</mat-label>
                    <input matInput [matDatepicker]="picker_valabilitate" formControlName="valabilitate" readonly
                        (focus)="picker_valabilitate.open()" />
                    <mat-error *ngIf="
                                        !form.controls['valabilitate'].valid &&
                                        form.controls['valabilitate'].touched
                                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_valabilitate"></mat-datepicker-toggle>
                    <mat-datepicker #picker_valabilitate></mat-datepicker>
                </mat-form-field>
            </div>
            <!-- <div class="add-field">
                <mat-label>Taxă achitată</mat-label>
                <mat-radio-group formControlName="taxa_achitata">
                  <mat-radio-button color="primary" *ngFor="let option of taxOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-radio-button>
                </mat-radio-group>
            </div> -->
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Registre CU noi: construire/desfiintare, ingineresti, operatiuni notariale, informare -->
        <div
            *ngIf="inputData.slug === 'construire_desfiintare' || inputData.slug === 'construire_desfiintare_ingineresti' || inputData.slug === 'operatiuni_notariale' || inputData.slug === 'certificate_urbanism_informare'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr registru</mat-label>
                    <input type="number" matInput formControlName="numar_certificat" />
                    <mat-error
                        *ngIf="!form.controls['numar_certificat'].valid && form.controls['numar_certificat'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_eliberarii'].valid && form.controls['data_eliberarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                    <mat-error
                        *ngIf="!form.controls['numar_cerere_registratura'].valid && form.controls['numar_cerere_registratura'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                    <mat-error *ngIf="!form.controls['numar_cerere'].valid && form.controls['numar_cerere'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_solicitarii'].valid && form.controls['data_solicitarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Adresă imobil</h3>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr extras de carte funciară</mat-label>
                    <input type="text" matInput formControlName="carte_funciara" />
                    <mat-error
                        *ngIf="!form.controls['carte_funciara'].valid && form.controls['carte_funciara'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scopul</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Registru Notificari -->
        <div *ngIf="inputData.slug === 'notificari'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr notificare</mat-label>
                    <input type="number" matInput formControlName="numar_notificare" />
                    <mat-error
                        *ngIf="!form.controls['numar_notificare'].valid && form.controls['numar_notificare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_eliberarii'].valid && form.controls['data_eliberarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                    <mat-error
                        *ngIf="!form.controls['numar_cerere_registratura'].valid && form.controls['numar_cerere_registratura'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                    <mat-error *ngIf="!form.controls['numar_cerere'].valid && form.controls['numar_cerere'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_solicitarii'].valid && form.controls['data_solicitarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Adresă imobil</h3>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr carte funciară</mat-label>
                    <input type="text" matInput formControlName="carte_funciara" />
                    <mat-error
                        *ngIf="!form.controls['carte_funciara'].valid && form.controls['carte_funciara'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scopul notificării</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- Registru Autorizatie de construire/desfiintare -->
        <div *ngIf="inputData.slug === 'autorizatie_construire_desfiintare'">
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr autorizație</mat-label>
                    <input type="number" matInput formControlName="numar_autorizatie" />
                    <mat-error
                        *ngIf="!form.controls['numar_autorizatie'].valid && form.controls['numar_autorizatie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data eliberării</mat-label>
                    <input matInput [matDatepicker]="picker_data_eliberarii" formControlName="data_eliberarii" readonly
                        (focus)="picker_data_eliberarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_eliberarii'].valid && form.controls['data_eliberarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_eliberarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_eliberarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Solicitare</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="numar_cerere_registratura" />
                    <mat-error
                        *ngIf="!form.controls['numar_cerere_registratura'].valid && form.controls['numar_cerere_registratura'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere (intern)</mat-label>
                    <input type="number" matInput formControlName="numar_cerere" />
                    <mat-error *ngIf="!form.controls['numar_cerere'].valid && form.controls['numar_cerere'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data solicitării</mat-label>
                    <input matInput [matDatepicker]="picker_data_solicitarii" formControlName="data_solicitarii"
                        readonly (focus)="picker_data_solicitarii.open()" />
                    <mat-error
                        *ngIf="!form.controls['data_solicitarii'].valid && form.controls['data_solicitarii'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_solicitarii"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_solicitarii></mat-datepicker>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Adresă imobil</h3>
            <div class="row">
                <div class="add-field col-md-8">
                    <mat-form-field appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="strada" />
                        <mat-error *ngIf="!form.controls['strada'].valid && form.controls['strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                        <mat-error *ngIf="!form.controls['numar'].valid && form.controls['numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Bloc</mat-label>
                    <input type="text" matInput formControlName="bloc" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scara</mat-label>
                    <input type="text" matInput formControlName="scara" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Etaj</mat-label>
                    <input type="text" matInput formControlName="etaj" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Apartament</mat-label>
                    <input type="text" matInput formControlName="apartament" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cadastral</mat-label>
                    <input type="number" matInput formControlName="numar_cadastral" />
                    <mat-error
                        *ngIf="!form.controls['numar_cadastral'].valid && form.controls['numar_cadastral'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Solicitant: Nume și Prenume</mat-label>
                    <input type="text" matInput formControlName="solicitant" />
                    <mat-error *ngIf="!form.controls['solicitant'].valid && form.controls['solicitant'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Scop</mat-label>
                    <input type="text" matInput formControlName="scop" />
                    <mat-error *ngIf="!form.controls['scop'].valid && form.controls['scop'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <h3 class="mt-3">Suprafețe</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață teren</mat-label>
                    <input type="number" matInput formControlName="suprafata_teren" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață construcție</mat-label>
                    <input type="number" matInput formControlName="suprafata_constructie" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață utilă</mat-label>
                    <input type="number" matInput formControlName="suprafata_utila" />
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Suprafață bucătării</mat-label>
                    <input type="number" matInput formControlName="suprafata_bucatarii" />
                </mat-form-field>
            </div>
            <h3 class="mt-3">Valori și termene</h3>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valoare lucrări</mat-label>
                    <input type="number" matInput formControlName="valoare_lucrari" />
                    <mat-error
                        *ngIf="!form.controls['valoare_lucrari'].valid && form.controls['valoare_lucrari'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valoare taxă</mat-label>
                    <input type="number" matInput formControlName="valoare_taxa" />
                    <mat-error *ngIf="!form.controls['valoare_taxa'].valid && form.controls['valoare_taxa'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Termen valabilitate</mat-label>
                    <input matInput [matDatepicker]="picker_valabilitate" formControlName="valabilitate" readonly
                        (focus)="picker_valabilitate.open()" />
                    <mat-error *ngIf="!form.controls['valabilitate'].valid && form.controls['valabilitate'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_valabilitate"></mat-datepicker-toggle>
                    <mat-datepicker #picker_valabilitate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Termen valabilitate execuție</mat-label>
                    <input type="text" matInput formControlName="durata_executie" />
                    <mat-error
                        *ngIf="!form.controls['durata_executie'].valid && form.controls['durata_executie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Întocmitor</mat-label>
                    <input type="text" matInput formControlName="intocmitor" />
                    <mat-error *ngIf="!form.controls['intocmitor'].valid && form.controls['intocmitor'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>